<template>
  <div class="sidebar-expanded">
    <div class="sidebar-expanded__top">
      <div class="sidebar-expanded__top__brand">

        <instance-profile-card
          :mask-shade="false"
          :InstanceInfo="InstanceInfo"
          :PersonalProfile="PersonalProfile">
        </instance-profile-card>

      </div>
    </div>
    <!-- end ~ sidebar-expanded__top -->
    <div class="sidebar-expanded__center">
      <div class="sidebar-expanded__menu">
        <el-menu
          :router="true"
          :default-active="$route.path"
          :unique-opened="true"
          class="el-menu--nuttrema-navigation-menu"
          @open="handleOpen"
          @close="handleClose">

          <el-menu-item index="/" :route="{ name: 'landing-login' }" key="login">
            <span>{{ $t('label.login') }}</span>
          </el-menu-item>

          <el-menu-item index="/professional/forgot-password" :route="{ name: 'professional-forgot-password' }" key="professional-forgot-password">
            <span>{{ $t('label.forgot_password') }}</span>
          </el-menu-item>

          <el-menu-item v-if="isActive('professional-reset-password')" index="/professional/reset-password" :route="{ name: 'professional-reset-password' }" key="professional-reset-password">
            <span>{{ $t('label.reset_password') }}</span>
          </el-menu-item>

          <el-menu-item v-if="isActive('professional-verify-email')" index="/professional/verify-email" :route="{ name: 'professional-verify-email' }" key="professional-verify-email">
            <span>{{ $t('label.verify_email') }}</span>
          </el-menu-item>

          <el-menu-item v-if="isActive('professional-join-instance')" index="/professional/join-instance" :route="{ name: 'professional-join-instance' }" key="professional-join-instance">
            <span>{{ $t('label.join_instance') }}</span>
          </el-menu-item>

          <el-menu-item v-if="isActive('professional-resend-completion-token')" index="/professional/resend-completion-token" :route="{ name: 'professional-resend-completion-token' }" key="professional-resend-completion-token">
            <span>{{ $t('label.complete_registration') }}</span>
          </el-menu-item>

        </el-menu>
      </div>
    </div>


    <div class="sidebar-expanded__bottom" v-if="_get(InstanceInfo, 'data.instance_type') === 'system'">
      <div class="promotion-banner">
        <h4 class="ttl">{{ $t('label.diet_creator') }}</h4>
        <p class="dsc">{{ $t('label.the_most_extensive_solution') }}</p>
        <router-link
          class="el-button el-button el-button--nuttrema-orange"
          :to="{ name: 'create-instance-professional-step-one' }">
          {{ $t('label.free_trial') }}
        </router-link>
      </div>
    </div>

</div>
</template>

<script>
import { get } from 'lodash';
import { NavigationsPublic } from 'data';
import SidebarMenu from 'components/ui/menu/sidebar-menu';

import InstanceProfileCard from 'components/ui/card/instance-profile-card';

export default {
  name: 'sidebar-menu-level-auth-expanded',
  mixins: [SidebarMenu],
  components: {
    InstanceProfileCard,
  },
  data() {
    return {
      navigationLinks: NavigationsPublic,
    };
  },
  computed: {
    InstanceInfo() {
      return this.$store.getters.InstanceInfo;
    },
    PersonalProfile() {
      return this.$store.getters.PersonalProfile;
    },
  },
  methods: {
    isActive(name) {
      const current = get(this.$route, 'name', false);
      return current && current === name;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";

  .promotion-banner {
    text-align: center;
    margin: 2em 1.25em;
    color: #475669;
    .ttl {
      line-height: 1.25;
      font-weight: 600;
      margin-bottom: 0.5em;
      font-size: 1.25rem;
    }
    .dsc {
      font-size: 1.05rem;
      line-height: 1.15;
      margin-bottom: 1em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/menu/auth/sidebar-menu-level-auth-expanded.vue